export default async function activated({ $auth, redirect }) {
	if ($auth.loggedIn) {
		const { user } = $auth;
		if (user && user.activated === false) {
			redirect({ name: 'index' });
		}
	}
}
